// extracted by mini-css-extract-plugin
export var pageSection = "support-module--pageSection--m7SCi";
export var sectionTitle = "support-module--sectionTitle--gMeIo";
export var guideList = "support-module--guideList--njX-3";
export var faqSections = "support-module--faqSections--an00a";
export var getInContact = "support-module--getInContact--N3wB3";
export var contactBody = "support-module--contactBody--Ubcfl";
export var contactButton = "support-module--contactButton--Wb8A8";